// extracted by mini-css-extract-plugin
export default {"navigation_box":"index_navigation_box_W-y2a","navigation":"index_navigation_w56NT clearfix"};